"use strict";import{LogBox as RNLogBox}from"react-native";const LogBox=RNLogBox,noop=()=>{};export const addLogBoxLog=LogBox?.addLog?.bind(LogBox)??noop;